export const MAIL_NOTIFICATION_MUTATION = `
  mutation MailNotification($input: NotificationEmailInput!) {
    mailNotification(input: $input) {
      success
      message
      timestamp
      messageId
    }
  }
`; 